import React from 'react'
import PropTypes from 'prop-types'

const VIP_STYLE = {
    color: '#d9534f',
    fontSize: '24px',
}


const EscalationIcon = ({ inEscalation }) => {
    if (!inEscalation) {
        return null
    }
    return (<i className="fa fa-exclamation-triangle" style={VIP_STYLE}/>)
}


EscalationIcon.propTypes = {
    inEscalation: PropTypes.bool,
}

export default EscalationIcon



// WEBPACK FOOTER //
// ./src/modules/form/component/EscalationIcon.js